module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1cMEF"))).then(() => parcelRequire('d0iPb'));